import { Component, Prop, Vue } from 'vue-property-decorator';
import { PAGE_NAMES } from '@/constants';
import Navigation from '@/components/common/sidebar/navigation/Navigation.vue';
import NavigationItem from '@/components/common/sidebar/navigation-item/NavigationItem.vue';

@Component({
  components: {
    Navigation,
    NavigationItem
  }
})
export default class Sidebar extends Vue {
  @Prop({ default: false }) private drawer: boolean;

  sideBarShown = false;

  closeSidebar(): void {
    this.sideBarShown = !this.sideBarShown;
    this.$emit(`onCloseSideBar`, true);
  }

  navigateToWelcomePage(): void {
    this.$router.push({ name: PAGE_NAMES.WELCOME });
  }

  created(): void {
    this.sideBarShown = this.drawer;
  }
}
